export default __webpack_public_path__ + "static/media/circle-minus.edb7c8f4.svg";